export default __webpack_public_path__ + "static/media/calculationImg.9fa5ef7d.svg";